module.exports = __webpack_public_path__ + "static/img/paspoortrechts.3f65535.png";